import React, { Component, Fragment } from "react";
import {
  Form,
  Divider,
  Grid,
  Checkbox,
  Input,
  Dropdown
} from "semantic-ui-react";
import { CustomLabel } from "../../../../../components/labels/labels";

class PrelimSiteDetails extends Component {
  state = {};
  render() {
    var {
      siteDetails,
      prelimDetails,
      countryOptions,
      stateOptions,
      cityOptions,
      formType
    } = this.props;

    return (
      <Fragment>
        <Divider hidden />
        <label style={{ marginLeft: "0px", fontWeight: "bold" }}>
          PRELIMINARY SITE LOCATION SECTION
        </label>
        <Divider fitted />
        <br />
        <CustomLabel
          message={`NFPA 790, Clause 10.2.2 states “A preliminary evaluation for the field evaluation, if conducted, 
                shall be permitted to be conducted at the point of manufacturing, at interim points of distribution, 
                in the evaluating company’s facilities, or at the final installation site.”   
                A trip to the final installation site will be required to complete the process and apply the UL label`}
        />
        <Divider hidden />
        <Grid>
          {siteDetails?.others?.isProjectTab && (
            <Grid.Row>
              <Grid.Column>
                <Form.Field>
                  {
                    "Is the Preliminary Evaluation location the same as the Applicant details found in your account settings tab?"
                  }
                </Form.Field>
                <Form.Field>
                  <Checkbox
                    radio
                    label="Yes"
                    name="prelimSameAsApplicantRadioGroup"
                    value="true"
                    checked={
                      siteDetails?.others?.prelimSameAsApplicant === "true"
                    }
                    onChange={(e, { value }) => {
                      this.props.handleCheckboxChange(
                        "prelimSameAsApplicant",
                        value,
                        "others"
                      );
                      this.props.handleFillPrelimSiteDetails(value, "prelim");
                    }}
                  />
                  &nbsp;&nbsp;&nbsp;
                  <Checkbox
                    radio
                    label="No"
                    name="prelimSameAsApplicantRadioGroup"
                    value="false"
                    checked={
                      siteDetails?.others?.prelimSameAsApplicant === "false"
                    }
                    onChange={(e, { value }) => {
                      this.props.handleCheckboxChange(
                        "prelimSameAsApplicant",
                        value,
                        "others"
                      );
                      this.props.handleFillPrelimSiteDetails(value, "prelim");
                    }}
                  />
                </Form.Field>
              </Grid.Column>
            </Grid.Row>
          )}
          <Grid.Row>
            <Grid.Column>
              <Form.Field
                id="form-input-control-lcn"
                control={Input}
                label="* Business/Residence Name"
                placeholder="Enter business/residence name"
                name="residenceName"
                onChange={(e) => {
                  this.props.handleChange(e, formType);
                }}
                value={prelimDetails?.residenceName || ""}
                error={this.props.getErrorFor("residenceName", formType)}
                autoComplete="off"
                readOnly={
                  prelimDetails?.residenceNameEnable == "true" ? true : false
                }
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={3}>
            <Grid.Column>
              <Form.Field
                id="form-input-control-lcn"
                control={Input}
                label="* Street Address Line 1"
                placeholder="Enter address line 1"
                name="addressLine1"
                onChange={(e) => {
                  this.props.handleChange(e, formType);
                }}
                value={prelimDetails?.addressLine1 || ""}
                error={this.props.getErrorFor("addressLine1", formType)}
                autoComplete="off"
                readOnly={
                  prelimDetails?.addressLine1Enable == "true" ? true : false
                }
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Field
                id="form-input-control-lcn"
                control={Input}
                label="Street Address Line 2"
                placeholder="Enter address line 2"
                name="addressLine2"
                onChange={(e) => {
                  this.props.handleChange(e, formType);
                }}
                value={prelimDetails?.addressLine2 || ""}
                error={this.props.getErrorFor("addressLine2", formType)}
                autoComplete="off"
                readOnly={
                  prelimDetails?.addressLine2Enable == "true" ? true : false
                }
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Field
                id="form-input-control-lcn"
                control={Input}
                label="Street Address Line 3"
                placeholder="Enter address line 3"
                name="addressLine3"
                onChange={(e) => {
                  this.props.handleChange(e, formType);
                }}
                value={prelimDetails?.addressLine3 || ""}
                error={this.props.getErrorFor("addressLine3", formType)}
                autoComplete="off"
                readOnly={
                  prelimDetails?.addressLine3Enable == "true" ? true : false
                }
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={4}>
            <Grid.Column>
              <Form.Field>
                <label>* Country</label>
                <Dropdown
                  compact
                  selection
                  placeholder="Select Country"
                  options={countryOptions || []}
                  selectOnBlur={false}
                  onChange={(e, properties) => {
                    this.props.handleDropdownChange(
                      "country",
                      properties.value,
                      formType
                    );
                    this.props.handleGetProjectStates(properties.value, 1);
                  }}
                  value={prelimDetails?.country || ""}
                  error={this.props.getErrorFor("country", formType)}
                  disabled={
                    prelimDetails?.countryEnable == "true" ? true : false
                  }
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column>
              <Form.Field>
                <label>* State</label>
                <Dropdown
                  compact
                  selection
                  placeholder="Select State"
                  options={stateOptions || []}
                  selectOnBlur={false}
                  onChange={(e, properties) => {
                    this.props.handleDropdownChange(
                      "state",
                      properties.value,
                      formType
                    );
                    this.props.handleGetProjectCities(properties.value, 1);
                  }}
                  value={prelimDetails?.state || ""}
                  error={this.props.getErrorFor("state", formType)}
                  disabled={prelimDetails?.stateEnable == "true" ? true : false}
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column>
              <Form.Field>
                <label>* City</label>
                <Dropdown
                  compact
                  selection
                  placeholder="Select City"
                  options={cityOptions || []}
                  selectOnBlur={false}
                  onChange={(e, properties) => {
                    this.props.handleDropdownChange(
                      "city",
                      properties.value,
                      formType
                    );
                  }}
                  value={prelimDetails?.city || ""}
                  error={this.props.getErrorFor("city", formType)}
                  disabled={prelimDetails?.cityEnable == "true" ? true : false}
                />
              </Form.Field>
            </Grid.Column>

            <Grid.Column>
              <Form.Field
                id="form-input-control-lcn"
                control={Input}
                label="* Postal Code"
                placeholder="Enter postal code"
                name="postalCode"
                onChange={(e) => {
                  this.props.handleChange(e, formType);
                }}
                value={prelimDetails?.postalCode || ""}
                error={this.props.getErrorFor("postalCode", formType)}
                autoComplete="new-password"
                readOnly={
                  prelimDetails?.postalCodeEnable == "true" ? true : false
                }
              />
            </Grid.Column>
          </Grid.Row>

          <CustomLabel message="SITE CONTACT DETAILS" />

          <Grid.Row columns={3}>
            <Grid.Column>
              <Form.Field
                id="form-input-control-lcn"
                control={Input}
                label="* Contact Name"
                placeholder="Enter contact name"
                name="siteContactName"
                onChange={(e) => {
                  this.props.handleChange(e, formType);
                }}
                value={prelimDetails?.siteContactName || ""}
                error={this.props.getErrorFor("siteContactName", formType)}
                autoComplete="new-password"
                readOnly={
                  prelimDetails?.siteContactNameEnable == "true" ? true : false
                }
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Field
                id="form-input-control-lcn"
                control={Input}
                label="* Phone No."
                placeholder="Enter phone no"
                name="siteContactOfficeNumber"
                onChange={(e) => {
                  this.props.handleChange(e, formType);
                }}
                value={prelimDetails?.siteContactOfficeNumber || ""}
                error={this.props.getErrorFor(
                  "siteContactOfficeNumber",
                  formType
                )}
                autoComplete="new-password"
                readOnly={
                  prelimDetails?.siteContactOfficeNumberEnable == "true"
                    ? true
                    : false
                }
              />
            </Grid.Column>
            <Grid.Column>
              <Form.Field
                id="form-input-control-lcn"
                control={Input}
                label="Mobile No."
                placeholder="Enter mobile no"
                name="siteContactMobileNumber"
                onChange={(e) => {
                  this.props.handleChange(e, formType);
                }}
                value={prelimDetails?.siteContactMobileNumber || ""}
                error={this.props.getErrorFor(
                  "siteContactMobileNumber",
                  formType
                )}
                autoComplete="new-password"
                readOnly={
                  prelimDetails?.siteContactMobileNumberEnable == "true"
                    ? true
                    : false
                }
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Form.Field
                id="form-input-control-lcn"
                control={Input}
                label="Email"
                placeholder="Enter email"
                name="siteContactEmailAddress"
                onChange={(e) => {
                  this.props.handleChange(e, formType);
                }}
                value={prelimDetails?.siteContactEmailAddress || ""}
                error={this.props.getErrorFor(
                  "siteContactEmailAddress",
                  formType
                )}
                autoComplete="new-password"
                readOnly={
                  prelimDetails?.siteContactEmailAddressEnable == "true"
                    ? true
                    : false
                }
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Fragment>
    );
  }
}

export default PrelimSiteDetails;
